'use strict';

import Cookies from 'js-cookie';
import { breakpointWatch, deleteMarketoCookie, sanitizeHtml  } from '../../_imports/shared/vue-utils.common';
import { apiUpdateLead } from '../../../api/marketo';

export default {
    mixins: [
        breakpointWatch,
        deleteMarketoCookie,
        sanitizeHtml,
    ],
    data() {
        return {
            ctaClickAfterCloseModal: false,
            resourceIsOpened: false,
            resourceCanBeViewed: true,
            successMessage: false,
            getLeadSuccess: false,
            formFieldsVisible: false,
            provider: '',
        }
    },
    methods: {
        hasMarketoCookie() {
            return Cookies.get('marketo_id');
        },
        formModalHasClosed() {
            if (this.hasMarketoCookie()
                && CoveoWebsite.forms.email) {
                if(this.setResourceDocumentUrlForCta) {
                    this.setResourceDocumentUrlForCta();
                }
                
                this.resourceCanBeViewed = true;

                if (this.$refs.razorPlayer) {
                    this.$refs.razorPlayer.classList.remove('gated');
                }
            }
        },
        closeModalAndOpenResource() {
            if(this.triggerFormModalClose) {
                this.triggerFormModalClose();
            }

            this.ctaClickAfterCloseModal = true;

            this.$nextTick(() => {
                this.openResource();
            });
        },
        openResource() {
            if (this.isResourceVideo) {
                if(this.openResourceVideo) {
                    this.openResourceVideo();
                }
            } else {
                this.$refs.resourceCta.click();
            }

            this.updateMarketoLeadAndPushDataLayer();

            this.resourceIsOpened = true;
        },
        getMarketoDetailIDUrl(config = {}) {
            if (config.marketoDetailIDUrl) {
                return config.marketoDetailIDUrl;
            }

            return config.resource.overrideMarketoDetailIDUrl ||
                   config.resource.form?.fields?.find(field => field.name === 'MarketoDetailIDUrl')?.value ||
                   window.location.pathname;
        },
        updateMarketoLeadAndPushDataLayerCore(config = {}, pageId = this.$el.id) {
            if(!config.resource) {
                return;
            }

            const marketoPayload = {
                MarketoDetailIDUrl: this.getMarketoDetailIDUrl(config),
                mktoAssetDownloadTitle: config.resource.title,
                mktoFormPageID: pageId
            };

            if(config.resource.externalLink) {
                marketoPayload.mktoAssetDownloadURL = config.resource.externalLink;
            } else if (config.documentUrl) {
                marketoPayload.mktoAssetDownloadURL = config.documentUrl;
            } else if (this.isResourceVideo) {
                switch (this.provider) {
                    case 'wistia':
                        marketoPayload.mktoAssetDownloadURL = `https://coveo.wistia.com/medias/${config.resource.video.videoCode}`;
                    break;
                }
            }

            for (const data in marketoPayload) {
                marketoPayload[data] = this.sanitizeHtml(marketoPayload[data]);
            }
                
            apiUpdateLead({
                formSerializeString: marketoPayload
            });
        },
    },
    watch: {
        fullyLoaded() {
            setTimeout(() => {
                this.$root.$on("successMessage", (data) => {
                    this.successMessage = data;
                });
    
                this.$root.$on("get-lead-success", () => {
                    this.getLeadSuccess = true;
                });
    
                this.$root.$on("show-form-fields-animation-begin", () => {
                    this.formFieldsVisible = true;
                    
                    if (this.onFormFieldsVisible) {
                        this.onFormFieldsVisible();
                    }
                });
    
                if (this.onFullyLoadedComplete) {
                    this.onFullyLoadedComplete();
                }
            }, 0);
        }
    }
}